var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3202 9.15527e-05C36.1202 9.15527e-05 40.0002 3.84009 40.0002 10.6601V29.3401C40.0002 36.1201 36.1402 40.0001 29.3402 40.0001H10.6602C3.84024 40.0001 0.000244141 36.1201 0.000244141 29.3401V10.6601C0.000244141 3.84009 3.84024 9.15527e-05 10.6602 9.15527e-05H29.3202ZM19.9802 11.0201C19.0602 11.0201 18.3202 11.7601 18.3202 12.6801V18.3201H12.6602C12.2202 18.3201 11.8002 18.5001 11.4802 18.8001C11.1802 19.1201 11.0002 19.5381 11.0002 19.9801C11.0002 20.9001 11.7402 21.6401 12.6602 21.6601H18.3202V27.3201C18.3202 28.2401 19.0602 28.9801 19.9802 28.9801C20.9002 28.9801 21.6402 28.2401 21.6402 27.3201V21.6601H27.3202C28.2402 21.6401 28.9802 20.9001 28.9802 19.9801C28.9802 19.0601 28.2402 18.3201 27.3202 18.3201H21.6402V12.6801C21.6402 11.7601 20.9002 11.0201 19.9802 11.0201Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c832f70b7a1e283d0307fcd2cb7de80a.svg";
export { ForwardRef as ReactComponent };